'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { requestFailedOrUninitialized } from 'redux-request-state/util/requestStateCheckers';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { fetchMultiDomainPublishingScopeChange } from 'ContentEditorUI/redux/actions/portalActions';
import { getMultiDomainPublishingScopeChangeRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
class PageSettingsContainerWrapper extends Component {
  componentDidMount() {
    const {
      multiDomainPublishingScopeChangeRequest
    } = this.props;
    if (requestFailedOrUninitialized(multiDomainPublishingScopeChangeRequest)) {
      this.props.fetchMultiDomainPublishingScopeChange();
    }
  }
  render() {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PageSettingsContainer
      }) => /*#__PURE__*/_jsx(PageSettingsContainer, {})
    });
  }
}
PageSettingsContainerWrapper.propTypes = {
  fetchMultiDomainPublishingScopeChange: PropTypes.func.isRequired,
  multiDomainPublishingScopeChangeRequest: PropTypes.object
};
const mapStateToProps = state => ({
  multiDomainPublishingScopeChangeRequest: getMultiDomainPublishingScopeChangeRequest(state)
});
export default connect(mapStateToProps, {
  fetchMultiDomainPublishingScopeChange
})(PageSettingsContainerWrapper);